import React, { useEffect, useRef } from 'react'
import Popup from '../../../components/Popup'
import './GenuineVideoPopup.scss'

type stylesConfig = {
  logo: any
  title: any
  background: any
}
interface GenuineVideoPopupProps {
  isVisible: boolean
  onClose: () => void
  logoUrl?: string
  videoUrl?: string
  title?: string
  closeButtonText?: string
  isLoading?: boolean
  autoCloseIn?: number
  className?: string
  styles?: stylesConfig
}

const GenuineVideoPopup: React.FC<GenuineVideoPopupProps> = ({
  isVisible,
  onClose,
  logoUrl,
  videoUrl,
  title,
  closeButtonText = 'Close',
  isLoading = false,
  autoCloseIn,
  className = '',
  styles = {
    logo: {},
    background: {},
    title: {},
  },
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (isVisible && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.warn('Video autoplay failed:', error)
      })
    }
  }, [isVisible])

  const handleVideoError = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    console.error('Video failed to load:', videoUrl)
    e.currentTarget.style.display = 'none'
  }

  const handleLogoError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.error('Logo failed to load:', logoUrl)
    e.currentTarget.style.display = 'none'
  }

  return (
    <Popup
      isVisible={isVisible}
      onClose={onClose}
      className={`genuine-video-popup ${className}`}
      isLoading={isLoading}
      autoCloseIn={autoCloseIn}
      animationDuration ={1000}
    >
      <div className='genuine-video-popup__content' style={styles.background}>
        {logoUrl && (
          <div className='genuine-video-popup__logo-container'>
            <img
              src={logoUrl}
              alt='Logo'
              className='genuine-video-popup__logo'
              onError={handleLogoError}
              style={styles.logo}
            />
          </div>
        )}

        {videoUrl && (
          <div className='genuine-video-popup__video-container'>
            <video
              ref={videoRef}
              src={videoUrl}
              className='genuine-video-popup__video'
              controls
              controlsList='nofullscreen nodownload noremoteplayback'
              disablePictureInPicture
              playsInline
              onError={handleVideoError}
            />
          </div>
        )}

        {title && (
          <div className='genuine-video-popup__title' style={styles.title}>
            {title.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < title.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </Popup>
  )
}

export default GenuineVideoPopup
